import { allowedEvents } from "./taxonomy";
export { allowedEvents } from "./taxonomy";

import { apiUrl, isAppsInTossHost } from "../api-url";

declare global {
	interface Window {
		__japangolmokTrackTossTripCreated?: () => void;
	}
}

export function track(name: string, properties: Record<string, string> = {}) {
	if (!allowedEvents.has(name) || typeof window === "undefined") return;
	if (name === "landing_view") {
		try {
			const key = "jgm-first-visit",
				first = Number(localStorage.getItem(key));
			if (!first) localStorage.setItem(key, String(Date.now()));
			else if (
				Date.now() - first >= 7 * 86400000 &&
				!localStorage.getItem("jgm-d7-observed")
			) {
				localStorage.setItem("jgm-d7-observed", "1");
				track("return_visit_d7");
			}
		} catch {}
	}
	if (name === "trip_created") {
		try {
			window.__japangolmokTrackTossTripCreated?.();
		} catch {
			/* Analytics must not interrupt the saved trip. */
		}
	}
	if (["localhost", "127.0.0.1"].includes(window.location.hostname)) return;
	const safe = Object.fromEntries(
		Object.entries(properties).filter(
			([key, value]) =>
				[
					"originAirport",
					"destinationAirport",
					"channel",
					"surface",
					"tripStage",
					"itemType",
				].includes(key) && value.length <= 16,
		),
	);
	const body = JSON.stringify({
		name,
		properties: safe,
		occurredAt: new Date().toISOString(),
		channel: isAppsInTossHost() ? "appsInToss" : "web",
	});
	if (navigator.sendBeacon)
		navigator.sendBeacon(
			apiUrl("/api/v1/events"),
			new Blob([body], { type: "application/json" }),
		);
}
